/* 配置错误处理 */

/*
 例子:
 {
     errcode: 'NO LOGIN',                         //错误代码
     prompt: '你还没有登录或登录超时,请登录...',      //错误提示,空字符为不提示
     url: '/login'                               //跳转地址,true为刷新当前页,空字符串为不跳转
     fun: function () {                          //操作方法,空字符串为无

     }
 }
 */

let is_init = true;
let array = [], num = 0;

export default {
	data: [{
		errcode: 'AUTHORIZATION_INVALID',
		prompt: '',
		url: '',
		fun: function(res) {
			array.push(res.option);

            if (is_init) {
                window.localStorage.removeItem('Authorization');
                getToken(array);
            }

            is_init = false;
            function getToken (array){
                tools.ajax({
                    url: '/api/init',
                    headers: {
                        'X-ISSIGN': 1
                    },
                    isLoading: true,
                    successFun: function(res) {
                        window.localStorage.setItem('Authorization', res.token);
                        window.localStorage.setItem('expires_time', res.expires_time);
                        window.localStorage.setItem('is_sign', res.is_sign);
                        window.localStorage.setItem('sk', res.sk);
                        next(array);
                    },
                    errorFun: function(error) {
                        log.error('获取签名失败');
                    },
                    type: 'GET'
                });
            };

            function next(dataArr) {
                for(let i = 0; i < dataArr.length; i++) {
                    num++;
                    tools.ajax(dataArr[i]);
                }
                if (num === dataArr.length) {
                    is_init = true;
                    array = [];
                    num = 0;
                }
            }
		}
	}, {
		errcode: 'NO LOGIN',
		prompt: '你还没有登录或登录超时,请登录...',
		url: '',
		fun: function() {
            tools.alert.error('你还没有登录或登录超时,请重新登录...');
            
            tools.cache.del('is_login');
            tools.cache.del('Authorization');
            tools.cache.del('sk');
            // window.location.reload();
			window.updateUserOrderStatus = function(is_user, order_status) {
				window.location.reload();
			}

			//触发登陆
			if(app.isAppVersion() == 'android') {
				window.android.userLoginOrOrderPay(0, '', '');
			}

			if(app.isAppVersion() == 'ios') {
				//ios触发登陆
				window.webkit.messageHandlers.userLoginOrOrderPay.postMessage({
					"is_user": '0'
				});
			}

			tools.router.push({
				path: '/root_login'
				// query: {
				// 	callback: location.href.replace(location.origin, '')
				// }
			});

		}
	}, {
        // 不是当前店铺会员
		errcode: 'NOT_CUR_SHOP_VIP',
		prompt: '',
		url: '',
		fun: function() {
            tools.alert.error('该账号不是当前店铺会员!');
            
            tools.cache.del('is_login');
            tools.cache.del('Authorization');
            tools.cache.del('sk');
            tools.cache.del('user');
            // window.location.reload();
			window.updateUserOrderStatus = function(is_user, order_status) {
				window.location.reload();
			}

			//触发登陆
			if(app.isAppVersion() == 'android') {
				window.android.userLoginOrOrderPay(0, '', '');
			}

			if(app.isAppVersion() == 'ios') {
				//ios触发登陆
				window.webkit.messageHandlers.userLoginOrOrderPay.postMessage({
					"is_user": '0'
				});
			}

			tools.router.push({
				path: '/root_login'
				// query: {
				// 	callback: location.href.replace(location.origin, '')
				// }
			});
		}
	}, {
        // 不是当前分销商的店铺
		errcode: 'NOT_CUR_AGENCY_SHOP',
		prompt: '',
		url: '',
		fun: function() {
            tools.alert.error('不是该账号的店铺!');
            
            tools.cache.del('is_login');
            tools.cache.del('Authorization');
            tools.cache.del('sk');
            tools.cache.del('user');
            // window.location.reload();
			window.updateUserOrderStatus = function(is_user, order_status) {
				window.location.reload();
			}

			//触发登陆
			if(app.isAppVersion() == 'android') {
				window.android.userLoginOrOrderPay(0, '', '');
			}

			if(app.isAppVersion() == 'ios') {
				//ios触发登陆
				window.webkit.messageHandlers.userLoginOrOrderPay.postMessage({
					"is_user": '0'
				});
			}

			tools.router.push({
				path: '/root_login'
				// query: {
				// 	callback: location.href.replace(location.origin, '')
				// }
			});
		}
	}, {
        // 店铺不存在
		errcode: 'SHOP_NO_FOUND',
		prompt: '',
		url: '',
		fun: function() {
            tools.alert.error('店铺不存在,请重新登录...');
            
            tools.cache.del('is_login');
            tools.cache.del('Authorization');
            tools.cache.del('sk');
            tools.cache.del('user');

            window.sessionStorage.removeItem('shop');
			window.sessionStorage.removeItem('share_uidcode');
			window.history.pushState(null,null,tools.url.removeURLParameter(['shop','share_uidcode']));

            // window.location.reload();
			window.updateUserOrderStatus = function(is_user, order_status) {
				window.location.reload();
			}

			//触发登陆
			if(app.isAppVersion() == 'android') {
				window.android.userLoginOrOrderPay(0, '', '');
			}

			if(app.isAppVersion() == 'ios') {
				//ios触发登陆
				window.webkit.messageHandlers.userLoginOrOrderPay.postMessage({
					"is_user": '0'
				});
			}

			tools.router.push({
				path: '/root_login'
				// query: {
				// 	callback: location.href.replace(location.origin, '')
				// }
			});
		}
	}]

}


// WEBPACK FOOTER //
// ./src/auth/error_handle.js